define(
  'app/views/dc_multi_use_modal_view',['app/setup'],
  function (takhfifan) {

    takhfifan.dcMultiUseModal = takhfifan.BaseView.extend({

      events: {
        'click .tkh-dc-multiUse__copy-btn': 'copyCode',
        'click .tkh-dc-multiUse__partner-btn': 'goToPartnerWebsite',
        'click #dc-multi-use-modal__condition-title': 'toggleConditionText'
      },

      initialize: function (options) {

        takhfifan.eventHub.on('dc:multiUseModal', function (options) {
          if (options.code  === 'no_code') {
            $('.vipPopup').css('display', 'none');
            $('.freePopup').css('display', 'block');
          } else {
            $('.freePopup').css('display', 'none');
            $('.vipPopup').css('display', 'block');
          }
          this.$el.find(".tkh-dc-multiUse-title__text").text(options.title);
          this.$el.find(".dc-multi-use-modal___store-title").text(options.title);
          this.$el.find(".tkh-dc-multiUse-code__code").val(options.code);
          this.$el.find(".tkh-dc-multiUse-condition__text").html(options.highlight);
          this.pid = options.pid;
          this.vendorId = options.vendorId;

          if(options.partnerURL) {
            this.partnerURl = options.partnerURL;
          } else {
            this.$el.find(".tkh-dc-multiUse__partner-btn").prop("disabled", true);
          }

          this.showPopup();
        }, this);

        takhfifan.eventHub.on('modal:disableTriggerElement', function (options) {
          this.$el.hide();
          $('.tkh-dc-multiUse-condition__text').css('display', 'none');
          $('#dc-multi-use-modal__condition-title').removeClass('moreIcon');
        }, this);
      },

      showPopup: function () {
        takhfifan.eventHub.trigger('modal:showModalWithContent',
          {
            triggerElement: this.$el,
            fadeTimeIn: 400,
            elementToOperate: this.$el
          });
        this.$el.show();
      },

      copyCode: function () {
        var copyText = document.getElementById("dc-multi-use-modal-code__code");
        copyText.select();
        document.execCommand("copy");
        takhfifan.eventHub.trigger('dc:copyCode',
          {productID: this.pid , vendorId: this.vendorId});
      },

      goToPartnerWebsite: function () {
        var btn = $('.tkh-grouped-ext-buy-button'),
            ip = btn.data('userIp'),
            rainmanVendorId = btn.data('rainmanVendorId'),
            url = new URL(this.partnerURl)
        ;
        if(rainmanVendorId && rainmanVendorId !== "" && rainmanVendorId !== null){
          $.ajax({
            url: "/v4/api/morpheus/tokens",
            type: 'POST',
            tryCount : 0,
            retryLimit : 1,
            dataType: 'json',
            contentType: "application/json",
            data: JSON.stringify({
              "vendor": rainmanVendorId,
              "promotion": this.pid,
              "destination": this.partnerURl,
              "ip": ip
            }),
            success:function(data) {
              url.searchParams.append('token', data.token);
              window.open(url ,'_blank');
              takhfifan.eventHub.trigger('dc:goToPartnerWebSite',
                {productID: this.pid , vendorId: this.vendorId, token:data.token});
            },
            error: function(xhr){
              if(xhr.status===500){
                this.tryCount++;
                if (this.tryCount <= this.retryLimit) {
                  $.ajax(this);
                  return;
                }
                else{
                  window.open(url ,'_blank');
                  takhfifan.eventHub.trigger('dc:goToPartnerWebSite',
                    {productID: this.pid , vendorId: this.vendorId});
                }
              }
            }});
        }
        else{
          window.open(url ,'_blank');
          takhfifan.eventHub.trigger('dc:goToPartnerWebSite',
            {productID: this.pid , vendorId: this.vendorId});
        }
      },

      toggleConditionText: function (event) {
        event.stopImmediatePropagation();
        $('.tkh-dc-multiUse-condition__text').toggle();
        $('#dc-multi-use-modal__condition-title').toggleClass('moreIcon');
      }
    })
  });

